<nz-page-header nzBackIcon [nzGhost]="false">
  <nz-page-header-title i18n>Catalogs</nz-page-header-title>
  <nz-page-header-subtitle i18n>Update and manage color catalogs</nz-page-header-subtitle>
  <nz-page-header-extra>
    <nz-space>
      <nz-upload *nzSpaceItem
        [nzAction]="state.uploadUrl"
        >
        <button nz-button nzType="primary">
          <span nz-icon nzType="upload"></span>
          <span i18n>Upload Catalog</span>
        </button>
      </nz-upload>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>
<nz-table #expandTable [nzData]="state.all" nzTableLayout="fixed">
  <thead>
    <tr>
      <th i18n>Name</th>
      <th i18n>Version</th>
      <th i18n>ID</th>
      <th i18n>Active</th>
      <th i18n>Actions</th>
    </tr>
  </thead>
  <tbody>
    @for (catalogs of table.data; track catalogs) {
      <tr>
        <td nzShowExpand="true" [nzIndentSize]="0">
          {{ catalogs.name }}
        </td>
        <td>
          {{ catalogs.version }}
        </td>
        <td>
          {{ catalogs.externalId }}
        </td>
        <td>
          <nz-switch
            [ngModel]="catalogs.isActive"
            (ngModelChange)="state.setActive(catalogs.id!, $event)"
            [nzCheckedChildren]="checkedTemplate"
            [nzUnCheckedChildren]="unCheckedTemplate"
          ></nz-switch>
        </td>
        <td>
          <!--        <button nz-button nzType="dashed" nzShape="circle" nzSize="default"><span nz-icon nzType="download"></span>-->
        <!--        </button>-->
      </td>
    </tr>
    @for (version of catalogs.versions; track version) {
      <tr>
        <td nzShowExpand="false" [nzIndentSize]="1">
        </td>
        <td>
          {{ version.version }}
        </td>
        <td>
          {{ version.externalId }}
        </td>
        <td>
          <nz-switch
            [ngModel]="version.isActive"
            (ngModelChange)="state.setActive(version.id!, $event)"
            [nzCheckedChildren]="checkedTemplate"
            [nzUnCheckedChildren]="unCheckedTemplate"
          ></nz-switch>
        </td>
        <td>
          <!--          <button nz-button nzType="dashed" nzShape="circle" nzSize="default"><span nz-icon nzType="download"></span>-->
        <!--          </button>-->
      </td>
    </tr>
  }
}
</tbody>
</nz-table>
<ng-template #checkedTemplate><span nz-icon nzType="check"></span></ng-template>
<ng-template #unCheckedTemplate><span nz-icon nzType="close"></span></ng-template>

